<template>
  <div>
    <el-button class="clear" @click="clickClear">クリア</el-button>
    <el-button type="primary" class="search" @click="clickSearch">検索</el-button>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    form: String
  },
  data () {
    return {}
  },
  methods: {
    clickClear () {
      this.$emit('clear')
    },
    clickSearch () {
      this.$emit('search')
    }
  }
}
</script>

<style lang="scss" scoped>
.clear,
.search {
  width: 8em;
}
</style>
